import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["navClass", "contentClass", "nested", "nestedClass", "offset", "reflow", "events", "activeHandle", "deactiveHandle", "clsPrefix"];

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.string.anchor.js";
import "core-js/modules/es6.string.link.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Gumshoe from 'gumshoejs';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  selector: PropTypes.string.isRequired,
  //选择器
  offset: PropTypes.any,
  //偏移量
  navClass: PropTypes.string,
  //当前被激活锚点新增的类名
  contentClass: PropTypes.string,
  //当前被激活的区域
  nested: PropTypes.bool,
  nestedClass: PropTypes.string,
  reflow: PropTypes.bool,
  event: PropTypes.bool,
  //是否添加监听事件
  activeHandle: PropTypes.func,
  //被激活的回调
  deactiveHandle: PropTypes.func //激活后的回调

};
var defaultProps = {
  navClass: 'active',
  // applied to the nav list item
  contentClass: 'active',
  // applied to the content
  // Nested navigation
  nested: false,
  // if true, add classes to parents of active link
  nestedClass: 'active',
  // applied to the parent items
  // Offset & reflow
  offset: 0,
  // how far from the top of the page to activate a content area
  reflow: false,
  // if true, listen for reflows
  // Event support
  events: true,
  // if true, emit custom events
  clsPrefix: 'u-anchor',
  activeHandle: function activeHandle() {},
  deactiveHandle: function deactiveHandle() {}
};
var Anchor = (_dec = WebUI({
  name: "anchor",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Anchor, _Component);

  var _super = _createSuper(Anchor);

  function Anchor() {
    _classCallCheck(this, Anchor);

    return _super.apply(this, arguments);
  }

  _createClass(Anchor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var props = this.props;
      this.anchor = new Gumshoe(props.selector, _objectSpread({}, props));
      if (!this.anchorDOM) return;
      this.anchorDOM.addEventListener('gumshoeActivate', function (event) {
        // The list item
        var li = event.target; //列表
        // The link

        var link = event.detail.link; //a标签
        // The content

        var content = event.detail.content; //内容区域

        props.activeHandle(li, link, content);
      });
      this.anchorDOM.addEventListener('gumshoeDeactivate', function (event) {
        var li = event.target; //列表
        // The link

        var link = event.detail.link; //a标签
        // The content

        var content = event.detail.content; //内容区域

        props.deactiveHandle(li, link, content);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.anchor && this.anchor.setup();
      this.anchor && this.anchor.detect();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.anchor && this.anchor.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          navClass = _this$props.navClass,
          contentClass = _this$props.contentClass,
          nested = _this$props.nested,
          nestedClass = _this$props.nestedClass,
          offset = _this$props.offset,
          reflow = _this$props.reflow,
          events = _this$props.events,
          activeHandle = _this$props.activeHandle,
          deactiveHandle = _this$props.deactiveHandle,
          clsPrefix = _this$props.clsPrefix,
          others = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("div", _extends({
        className: clsPrefix,
        ref: function ref(_ref) {
          _this.anchorDOM = _ref;
        }
      }, others), this.props.children);
    }
  }]);

  return Anchor;
}(Component)) || _class);
;
Anchor.propTypes = propTypes;
export default Anchor;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-anchor/src/Anchor.js